import React, { useEffect, useState } from 'react'
import './css/Cherche.css'
import FilterListIcon from '@material-ui/icons/FilterList';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import SearchIcon from '@material-ui/icons/Search';
import { Link } from '@material-ui/core';
var aa=5;

function Cherche() {
    var [search,set]=useState('');
    function boc(e){
        e.preventDefault();
        var search=document.getElementById('search').value;
        var catégories=document.getElementById('catégories').value;
        var city0=document.getElementById('city0').value;
        var li=[];
        li.push("https://avito-clone.web.app/","/Search/sea=",search,"&city=",city0,"&catégories=",catégories);
        window.location.href = `${li.join("")}`;
        
    }
    
    
    return (
        <div className="A">
            <form>
                
                <input onChange={e=>{set(e.target.value)}} style={{cursor:"auto"}} type="text" id="search" name="search" placeholder="Que recherchez-vous ?"/>
                <div className="icos">
                    <FilterListIcon className="i"/>
                    <select name="catégories" id="catégories">
                        <option value="0">Toutes les catégories</option>
                        <option style={{backgroundColor: "#dcdcc3", fontWeight:"bold"}} value="INFORMATIQUE ET MULTIMEDIA">-- INFORMATIQUE ET MULTIMEDIA --</option>
                        <option value="Téléphones">Téléphones</option>
                        <option value="Tablettes">Tablettes</option>
                        <option value="Ordinateurs portables">Ordinateurs portables</option>
                        <option value="Ordinateurs de bureau">Ordinateurs de bureau</option>
                        <option value="accessoires informatique et gadgets">Accessoires informatique et Gadgets</option>
                        <option value="Jeux vidéo et Consoles">Jeux vidéo et Consoles</option>
                        <option value="Appareils photo et Caméras">Appareils photo et Caméras</option>
                        <option value="Télévisions">Télévisions</option>
                        <option value="Image &amp; Son">Image &amp; Son</option>
                        <option value="auto_neuf">-- AUTO NEUF --</option>
                        <option style={{backgroundColor: "#dcdcc3", fontWeight:"bold"}} value="VEHICULES">-- VEHICULES --</option>
                        <option value="Voitures">Voitures</option>
                        <option value="Motos">Motos</option>
                        <option value="Vélos">Vélos</option>
                        <option value="Véhicules Professionnels">Véhicules Professionnels</option>
                        <option value="Bateaux">Bateaux</option>
                        <option value="Pièces et Accessoires pour véhicules">Pièces et Accessoires pour véhicules</option>
                        <option value="new_construction">-- IMMO NEUF --</option>
                        <option style={{backgroundColor: "#dcdcc3", fontWeight:"bold"}} value="1000">-- IMMOBILIER --</option>
                        <option value="1010">Appartements</option>
                        <option value="1020">Maisons et Villas</option>
                        <option value="1050">Bureaux et Plateaux</option>
                        <option value="1060">Magasins, Commerces et Locaux industriels</option>
                        <option value="1080">Terrains et Fermes</option>
                        <option value="1030">Locations de vacances</option>
                        <option value="1100">Colocations</option>
                        <option value="1090">Autre Immobilier</option>
                        <option style={{backgroundColor: "#dcdcc3", fontWeight:"bold"}} value="3000">-- POUR LA MAISON ET JARDIN --</option>
                        <option value="3010">Electroménager et Vaisselles</option>
                        <option value="3020">Meubles et Décoration</option>
                        <option value="3040">Jardin et Outils de bricolage</option>
                        <option style={{backgroundColor: "#dcdcc3", fontWeight:"bold"}} value="8000">-- HABILLEMENT ET BIEN ETRE --</option>
                        <option value="3050">Vêtements</option>
                        <option value="3150">Chaussures</option>
                        <option value="3160">Montres et Bijoux</option>
                        <option value="3060">Sacs et Accessoires</option>
                        <option value="3030">Vêtements pour enfant et bébé</option>
                        <option value="3130">Equipements pour enfant et bébé</option>
                        <option value="3070">Produits de beauté</option>
                        <option style={{backgroundColor: "#dcdcc3", fontWeight:"bold"}} value="4000">-- LOISIRS ET DIVERTISSEMENT --</option>
                        <option value="4010">Sports et Loisirs</option>
                        <option value="4030">Animaux</option>
                        <option value="4070">Instruments de Musique</option>
                        <option value="4060">Art et Collections</option>
                        <option value="4050">Voyages et Billetterie</option>
                        <option value="4040">Films, Livres, Magazines</option>
                        <option style={{backgroundColor: "#dcdcc3", fontWeight:"bold"}} value="6000">-- EMPLOI ET SERVICES --</option>
                        <option value="6010">Offres d'emploi</option>
                        <option value="6130">Offres de stages</option>
                        <option value="6050">Centre d'appels</option>
                        <option value="6080">Cadres</option>
                        <option value="6140">Métiers IT</option>
                        <option value="6060">Femmes de Ménages, Nounous et Chauffeurs</option>
                        <option value="6070">Travaux de maison</option>
                        <option value="6020">Demandes d'emploi</option>
                        <option value="6030">Services</option>
                        <option value="6040">Cours et Formations</option>
                        <option style={{backgroundColor: "#dcdcc3", fontWeight:"bold"}} value="9000">-- ENTREPRISES --</option>
                        <option value="6100">Business et Affaires commerciales</option>
                        <option value="6090">Matériels Professionnels</option>
                        <option value="6120">Stocks et Vente en gros</option>
                        <option style={{backgroundColor: "#dcdcc3", fontWeight:"bold"}} value="7000">-- Autres --</option>
                        <option value="7010">AUTRES</option>
                    </select>
                </div>
                <div className="icos">
                    <LocationOnOutlinedIcon className="i"/>
                    <select name="city" id="city0">
                        <option value="3" selected="">Tout le Maroc</option>
                        <option value="Casablanca" > Casablanca</option>
                        <option value="Casablanca"> Grand Casablanca</option>
                        <option style={{backgroundColor: "#dcdcc3", fontWeight:"bold"}}value="0" disabled="disabled">-- AUTRES VILLES --</option>
                        <option id="searcharea_expanded_fisrt_option" value="Ain Harrouda"> Ain Harrouda </option>
                        <option value="Bouskoura"> Bouskoura </option>
                        <option value="Mediouna"> Mediouna </option>
                        <option value="Mohammedia"> Mohammedia </option>
                        <option value="Nouaceur"> Nouaceur </option>
                        <option value="Tamaris"> Tamaris </option>
                        <option value="El Majjatia Ouled Taleb"> El Majjatia Ouled Taleb </option>
                        <option value="Lahraouyine"> Lahraouyine </option>
                        <option value="Sidi Hajjaj Oued Hassar"> Sidi Hajjaj Oued Hassar </option>
                        <option value="Tit Mellil"> Tit Mellil </option>
                        <option value="Dar Bouazza"> Dar Bouazza </option>
                        <option value="Errahma"> Errahma </option>
                        <option value="Lamkansa"> Lamkansa </option>
                        <option value="Oulad Salah"> Oulad Salah </option>
                        <option value="Béni Yakhlef"> Béni Yakhlef </option>
                        <option value="Chellalate"> Chellalate </option>
                        <option value="Sidi Moussa Ben Ali"> Sidi Moussa Ben Ali </option>
                        <option value="Sidi Moussa El Majdoub"> Sidi Moussa El Majdoub </option>
                        <option value="3" style={{color : "red"}}>Choisir une autre ville...</option>
                    </select>
                </div>
                <div className="ic">
                    <SearchIcon className="i"/>
                    <input type="submit" value="" onClick={boc}/>
                </div>
            </form>
        </div>
    )
    
}
export default Cherche
